/** Copy for Member expectations welcome-pack page. */
export const MEMBER_EXPECTATIONS_CONTENT = {
  brand: 'AXONALL RESERVE',
  pageTitle: 'Member Expectations',
  callout: 'Reserve is built on selection, professionalism, and mutual respect.',
  items: [
    {
      n: 1,
      title: 'A circle built on quality, not volume',
      body: 'Axonall Reserve is intentionally selective. Membership is shaped around fit, standards, and the quality of participation, rather than broad trade access or passive sign-up.',
    },
    {
      n: 2,
      title: 'Meaningful engagement matters',
      body: 'Reserve is designed for members who intend to use the relationship thoughtfully. That includes engaging with the materials provided, exploring relevant opportunities, and participating with genuine seriousness where there is alignment.',
    },
    {
      n: 3,
      title: 'Professionalism is expected',
      body: 'Reserve should feel trusted, considered, and respectful at every stage. We expect clear communication, professional conduct, and a constructive working relationship with the Axonall team and fellow members.',
    },
    {
      n: 4,
      title: 'Studio access sits within Reserve',
      body: 'Axonall Studio is the private member space through which access comes to life. It should be used with the same professionalism and intention expected of the Reserve circle more broadly.',
    },
    {
      n: 5,
      title: 'Client relationships remain respected',
      body: 'Axonall is designed to support members, not compete with them. Journey Artisan support and member access are intended to strengthen delivery, while respecting the advisor’s central role in the client relationship.',
    },
    {
      n: 6,
      title: 'The circle will evolve with care',
      body: 'As Reserve grows, access, opportunities, and recognition will continue to evolve. Some aspects of the circle, including Black Key, remain intentionally selective and may be extended only to a limited number of members over time.',
    },
  ],
}
